import React from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";

const normalizePhone = (value) => {
  // Usuwamy spacje, myślniki, nawiasy i kropki
  let cleaned = value.replace(/[\s\-().]/g, "");
  // Jeśli ciąg nie zaczyna się od '+', dodajemy go
  if (cleaned && cleaned[0] !== "+") {
    cleaned = "+" + cleaned;
  }
  return cleaned;
};

const PhoneInputWrapper = ({ value, onChange, ...props }) => {
  // Funkcja handleChange przyjmuje drugi argument zawierający dane kraju
  const handleChange = (phoneValue, country) => {
    const normalizedValue = normalizePhone(phoneValue);
    onChange(normalizedValue, country);
  };

  return <PhoneInput value={value} onChange={handleChange} {...props} />;
};

export default PhoneInputWrapper;
